enum BankLinkFlow {
  HOSTED_SETUP = "HOSTED_SETUP",
  VERIFIED_LINK = "VERIFIED_LINK",
}

export default BankLinkFlow;
